module.exports = __webpack_public_path__ + "img/7.f06b10e9.png";